export const locale = {
  lang: 'de',
  data: {
    'TEMPLATE':{
      'PANT_TEMPLATE':{
        'INST_1':'Laden Sie die Fragevorlage herunter',
        'INST_2':'Nehmen Sie die notwendigen Änderungen an der vorlage vor',
        'INST_3':'Laden Sie die Fragevorlage',
        'BTN_DESC_PLAN':'Fragenvorlage',
        'BUSC_PLAN_TEX':'Klicken Sie hier, um nach den Vorlagenfragen zu suchen',
        'TEMP_CARG_TIT':'Vorlageninformation',
        'TOT_PREG':'Fragen insgesamt',
        'TOT_PREG_MODI':'Geänderte Fragen insgesamt',
        'TOT_PREG_NUE':'Neue Fragen gesamt',
        'TEMP_CARG_TIT_CAR':'Template information loaded',
        'COMPL_PAS_SIN_MODI':'Sie haben noch keine Änderung vorgenommen. Sie sind sicher, dass Sie den Schritt abschließen?',
        'SUCC_CAR_PLAN':'Die Vorlage wurde erfolgreich geladen. Bitte schließen Sie den Schritt ab',
        'COMPLE_PASO_CON_MODI':'Sind Sie sicher, dass Sie den Schritt mit den aktuell eingegebenen Änderungen abschließen wollen?',
        'NO_MODIF': 'Ändern Sie diesen Zelleninhalt nicht',
        'ERROR_CARGA':'Die Datei kann nicht hochgeladen werden. In einer oder mehreren eingeschränkten Zellen wurden Änderungen festgestellt. Laden Sie die Vorlage erneut herunter und nehmen Sie die gewünschten Änderungen vor, ohne die eingeschränkten Zellen zu ändern.\n\nEingeschränkte Zellen enthalten einen Kommentar, der angibt, dass ihr Inhalt nicht geändert werden sollte',
        'FORALL_EXCEDIDAS': 'Es wurde festgestellt, dass die Anzahl der Übungen 4All in der geladenen Vorlage vorhanden ist und die Anzahl der zulässigen Übungen überschreitet. Es wurden nur die Übungen geladen, die dem maximal zulässigen Wert entsprechen ',
        'OPCIONDEMOGRAFICOS': 'Diese Zelle muss einen unveränderten Wert aus dem demografischen Katalogblatt enthalten',
        'CARGANDO_PREGUNTAS': 'Fragen aus der Vorlage laden'
      },
      'CATALOGO_IDIOMAS':{
        'z1': 'Vereinfachtes Chinesisch',
        'z2': 'Traditionelles Chinesisch',
        'ko': 'Koreanisch',
        'ja': 'Japanisch',
        'pt':'Portugiesisch',
        'en':'Englisch',
        'fr':'Französisch',
        'de':'Deutsch',
        'it':'Italienisch',
        'es':'Spanisch',
        'tr':'Türkisch',
        'ms':'Malaiisch',
        'ro':'Rumänisch',
        'vi':'Vietnamesisch',
        'bg':'Bulgarisch',
        'hi':'Hindi',
        'ru':'Russisch',
        'mn':'Mongolisch',
        'nl': 'Niederländisch',
        'ar': 'Arabisch',
        'ua': 'ukrainisch',
        'id': 'Indonesisch',
      },
      'HOJAS_EXCEL':{
       'Instrucciones': 'Anleitung',
       'Catalogo':'Katalog',
       'Detalles': 'Einzelheiten',
       'CatDemograficos': 'Demografischer Katalog',
       'Nps':'Nps',
       'Reactivos':'Anweisungen',
       'Control':'Kontrolle',
       'Demograficos':'Demographics',
       'Abiertas':'Offen',
       'Forall':'Forall',
       'Adicionales':'Zusätzlich',
     },
     'COLUMNAS_H_CATA':{
       'ClaveIdiomas': 'LanguageKey',
       'NombreIdiomas':'LanguageName',
       'IDTipoPregunta': 'ID type vraag',
       'TiposPreguntas': 'Vraagtypes',
       'ClaveTipoElemento': 'Sleutel voor elementtype',
       'TiposElementos': 'Elementtypes',
       'CONTEM_TIP_PREG':{
         '1': 'NPS / Controle / Aanvullende vraag (meerkeuze, één antwoord)',
         '2_1': 'NPS / Controle / vraag met open einde, type open tekst',
         '2_2': 'NPS / Controle / open vraag, type numerieke tekst',
         '3': 'Vraag van het reactieve type',
         '4': 'Demografische type vraag (meerkeuze, één antwoord)',
         '5': 'Praktijk 4All',
         '6': 'Extra vraag (meerkeuze, meerdere antwoorden)',
       },
       'CONTEM_TIP_SEGM':{
         'question': 'Tekst van de vraag',
         'answer_1': 'Tekst van antwoord 1',
         'answer_2': 'Tekst van antwoord 2',
         'answer_n': 'Tekst van antwoord n',
         'practice': 'Tekst van praktijk 4All',
         'description': 'Tekst van beschrijving van praktijk 4All',
         'statement_1': 'Vraag 1 van praktijk 4All',
         'statement_2': 'Vraag 2 van praktijk 4All',
       }
     },
     'COLUMNAS_SECCION':{
      'Id': 'Id',
      'TipoDePregunta': 'QuestionType',
      'PalabrasClave': 'KeyWords',
      'NuevaPregunta': 'NewQuestion',
      'Eliminable':	'Elimineerbaar',
      'Editable':	'Bewerkbaar',
      'RespuestaObligatoria':	'VerplichtAntwoorden',
      'MostrarPregunta': 'ShowQuestion',
      'Dimension': 'Maat',
      'Competencia':	'Competentie',
      'Subcompetencia':	'Subcompetentie',
      'TipoDemografico': 'TypeDemografico',
      'practice': 'praktijk',
      'description': 'beschrijving',
      'statement_1': 'verklaring_1',
      'statement_2': 'verklaring_2',
      'question': 'vraag',
      'answer': 'antwoord',
      'OpcionOtro': 'Antworttyp „Andere“'
     }
    }
  }
};
